<template>
  <div
    class="inner_container"
    style="overflow: auto; padding: 0; margin: 0;"
    @click="$emit('update:addMenuOpen', false); accounts_tab = 'account_selector';"
  >
    <div class="field-group">
      <!-- Меню добавления: триггер - "+" в шапке блока (addMenuTarget), состояние управляется страницей -->
      <q-menu
        ref="acc_menu"
        :target="addMenuTarget || false"
        :model-value="addMenuOpen"
        @update:model-value="(val) => $emit('update:addMenuOpen', val)"
        @show="handleMenuShow"
        style="
          overflow: hidden;
          max-height: unset !important;
          height: unset !important;
          max-width: min-content;
        "
        no-shake
        persistent
        @hide="onAddMenuHide"
      >
              <q-tabs
                v-model="accounts_tab"
                dense
                class="text-grey bg-white"
                active-color="dark"
                indicator-color="accent"
                align="justify"
              >
                <q-tab name="account_selector" no-caps>
                  <b
                    >{{ $t('invoices_payments_unattached') }}</b
                  >
                </q-tab>
                <q-tab name="new_bill" no-caps :label="$t('invoice_creation')" />
                <q-tab name="new_payment" no-caps :label="$t('add_payment')" />
              </q-tabs>
              <q-tab-panels
                v-model="accounts_tab"
                animated
                class="full-height bg-white"
                style="overflow: hidden"
              >
                <q-tab-panel
                  name="account_selector"
                  class="bg-white full-height q-pa-xs"
                  style="overflow: hidden"
                >
                  <div class="q-ma-none q-pa-none">
                    <q-input
                      outlined
                      dense
                      ref="from_search_input"
                      color="white"
                      class="thin-input q-my-auto"
                      v-model="acc_search_text"
                      hide-bottom-space
                      clearable
                      autofocus
                      :clear-icon="clearIconName"
                      :placeholder="$t('search_label')"
                      debounce="300"
                      @clear="acc_search_text = ''"
                    >
                      <template v-slot:append>
                        <q-icon name="search" color="accent" />
                      </template>
                    </q-input>
                  </div>
                  <aux-selector
                    v-show="showSelector"
                    :model-type="29"
                    :set-id="projectId"
                    :filter-model-value="acc_search_text"
                    :show-search-header="false"
                    :input-index="0"
                    v-model="tmp_accounts"
                    :allow-multiple="false"
                  />
                </q-tab-panel>

                <q-tab-panel
                  name="new_bill"
                  class="bg-white full-height q-pa-none q-pb-sm"
                  style="overflow: hidden"
                >
                  <bill-create-form v-model="newBill" :incoming-only="false" />
                </q-tab-panel>

                <q-tab-panel
                  name="new_payment"
                  class="bg-white full-height q-pa-none q-pb-sm"
                  style="overflow: hidden"
                >
                  <payment-create-component v-model="newPayment" :incoming-only="false" />
                  <div class="row no-wrap justify-end q-mt-sm q-mr-md">
                    <q-btn
                      no-caps
                      :label="$t('attach')"
                      color="primary"
                      :disable="!canCreatePayment"
                      @click.stop="addNewPayment"
                      v-close-popup
                    />
                  </div>
                </q-tab-panel>
              </q-tab-panels>

              <div
                class="field-group"
                v-if="
                  (accounts_tab === 'account_selector' &&
                    selectedExistingBill &&
                    !selectedExistingBill.Counterparty?.Id) ||
                  accounts_tab === 'new_bill'
                "
              >
                <div class="field-group__row">
                  <div class="text-bold">{{ $t('select_counterparty_invoice') }}</div>
                  <div v-if="selectedExistingCP || !isNewCPModelEmpty">
                    {{
                      selectedExistingCP
                        ? selectedExistingCP.Name
                        : newCPModel.Name + ", " + newCPModel.INN
                    }}
                  </div>
                  <q-btn
                    dense
                    flat
                    color="accent"
                    size="md"
                    icon="add"
                    class="q-pa-none"
                  >
                    <!-- anchor="center right"
                    self="center left" -->
                    <q-menu
                      ref="acc_menu_cp"
                      style="
                        overflow: hidden;
                        max-height: unset !important;
                        height: unset !important;
                        max-width: min-content;
                      "
                      no-shake
                    >
                      <q-tabs
                        v-model="counterparties_tab"
                        dense
                        class="text-grey bg-white"
                        active-color="dark"
                        indicator-color="accent"
                        align="justify"
                      >
                        <q-tab name="project_cp" no-caps :label="projectName" />
                        <q-tab
                          name="new_cp"
                          no-caps
                          :label="$t('search_create_counterparty')"
                        />
                      </q-tabs>
                      <q-tab-panels
                        v-model="counterparties_tab"
                        animated
                        class="full-height bg-white"
                        style="overflow: hidden"
                      >
                        <q-tab-panel
                          name="project_cp"
                          class="bg-white full-height q-pa-xs"
                          style="overflow: hidden"
                        >
                          <div
                            v-for="(c, li) in tmp_project_cps_clients"
                            :key="'c_' + li"
                          >
                            <span class="q-mb-xs" style="font-weight: 500">{{
                              c.Name
                            }}</span>
                            <simple-selector
                              ref="cp_selector"
                              class="q-my-sm"
                              :data-to-entity="
                                (ent) => counterpartyFromFilter(ent)
                              "
                              :data-from-entity="
                                (ent) =>
                                  counterpartyToFilter(
                                    ent,
                                    this.theModel?.find((m) => m.Id === ent.Id),
                                  )
                              "
                              :object-filter="false"
                              :load-more="
                                (f, c, offset) => {
                                  if (offset > 0) {
                                    return [];
                                  }
                                  return tmp_project_cps_clients[li]
                                    .Counterparties;
                                }
                              "
                              :m-height="0"
                              filter_value=""
                              :element-type="12"
                              :single-load="true"
                              :hide-checkboxes="true"
                              @itemSelected="() => {}"
                              v-model="tmp_project_cps"
                              :allow-multiple="true"
                            />
                          </div>
                        </q-tab-panel>
                        <q-tab-panel
                          name="new_cp"
                          class="bg-white full-height q-pa-xs"
                          style="overflow: hidden"
                        >
                          <div v-if="!newCPMode" class="q-ma-none q-pa-none">
                            <q-input
                              outlined
                              dense
                              ref="from_search_input"
                              color="white"
                              class="thin-input q-my-auto"
                              v-model="cp_search_text"
                              hide-bottom-space
                              clearable
                              autofocus
                              :clear-icon="clearIconName"
                              :placeholder="$t('search_label')"
                              debounce="300"
                              @clear="cp_search_text = ''"
                            >
                              <template v-slot:append>
                                <q-icon name="search" color="accent" />
                              </template>
                            </q-input>
                          </div>
                          <q-btn
                            v-if="
                              [10, 12].includes(cp_search_text.length) &&
                              !newCPMode
                            "
                            :label="$t('add_new_counterparty')"
                            no-caps
                            flat
                            @click="CPShow"
                          />
                          <aux-selector
                            v-if="!newCPMode"
                            :model-type="28"
                            :input-index="0"
                            :filter-model-value="cp_search_text"
                            :show-search-header="false"
                            v-model="tmp_adding_cps"
                            :allow-multiple="false"
                          />
                          <counterparty-create-form
                            v-else
                            v-model="newCPModel"
                            :project-id="projectId"
                          />
                        </q-tab-panel>
                      </q-tab-panels>
                      <div class="row no-wrap justify-end q-my-sm q-mr-md">
                        <q-btn
                          v-if="newCPMode"
                          :label="$t('back')"
                          no-caps
                          flat
                          @click="newCPMode = false"
                        />
                        <q-btn
                          no-caps
                          :label="$t('select_counterparty')"
                          :disable="!selectedExistingCP && isNewCPModelEmpty"
                          color="primary"
                          @click.stop="selectBillCounterparty"
                        />
                      </div>
                    </q-menu>
                  </q-btn>
                </div>
              </div>

              <div
                v-if="
                  (selectedExistingCP &&
                    !selectedExistingCP.AttachedToClient) ||
                  (!isNewCPModelEmpty && !selectedExistingClient)
                "
                class="field-group"
              >
                <div class="field-group__row">
                  <div class="bold-name">{{ $t('client_for_counterparty') }}:</div>
                  <div v-if="selectedExistingClient">
                    {{ selectedExistingClient.Name }}
                  </div>
                  <q-btn
                    ref="clientMenuTrigger"
                    @click.stop="clientMenuVisible = !clientMenuVisible"
                    dense
                    flat
                    color="accent"
                    size="md"
                    icon="add"
                    class="q-pa-none"
                  />
                  <selector-popup
                    v-model:visible="clientMenuVisible"
                    :trigger-el="$refs.clientMenuTrigger"
                    :default-width="300"
                  >
                    <aux-selector
                      :model-type="27"
                      :input-index="0"
                      :allow-multiple="false"
                      :limit-height-to-container="true"
                      v-model="tmp_cp_clients"
                      @selectorClosed="clientMenuVisible = false"
                    />
                  </selector-popup>
                </div>
              </div>

              <div
                v-if="accounts_tab === 'account_selector'"
                class="row no-wrap justify-end q-my-xs q-mr-md q-mb-md"
              >
                <!-- $t('payment') : $t('invoice') -->
                <q-btn
                  no-caps
                  :label="
                    $t('attach')+' ' +
                    (selectedExistingPayment ? $t('payment_invoice') : $t('payment_invoice'))
                  "
                  :disable="!canAttachBill"
                  color="primary"
                  @click.stop="AttachBill"
                  v-close-popup
                >
                  <q-tooltip
                    v-if="attachHintText"
                    anchor="top middle"
                    self="bottom middle"
                  >
                    {{ attachHintText }}
                  </q-tooltip>
                </q-btn>
              </div>

              <div
                v-if="accounts_tab === 'new_bill'"
                class="row no-wrap justify-end q-my-sm q-mr-md q-mb-md"
              >
                <q-btn
                  no-caps
                  :label="$t('create_invoice')"
                  color="primary"
                  :disable="!canCreateBill"
                  @click.stop="addNewBill"
                  v-close-popup
                >
                  <q-tooltip
                    v-if="createBillHintText"
                    anchor="top middle"
                    self="bottom middle"
                  >
                    {{ createBillHintText }}
                  </q-tooltip>
                </q-btn>
              </div>
      </q-menu>
      <div class="file-list">
        <!-- <movement-row v-for="(conn, i) in billInfoContainer?.Connections?.filter(el => el.Descriptor === 1)" :key="'conn_'+i" :el="conn.Income" /> -->
        <table v-if="tmp_connections.length" class="dialog-table">
          <thead>
            <tr>
              <th
                style="
                  font-weight: 400;
                  color: #4D4D4D;
                  font-size: 14px;
                  text-transform: unset;
                  vertical-align: bottom;
                "
              >
                {{ tmp_connections[0].name }}:
              </th>
              <th>Кол-во/% {{ $t('here') }}</th>
              <th>{{ $t('amount_lower') }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tbody style="display: contents" v-for="(row, idx) in tmp_connections.slice(1)" :key="'conn_line_' + idx">
              <tr>
                <td
                  :style="
                    row.header_row ? 'padding: 5px; padding-top: 16px;' : ''
                  "
                >
                  <div class="row no-wrap justify-between">
                    <div class="row no-wrap">
                      <span style="font-weight: 400; color: #4D4D4D;"
                        >{{ !row.header_row ? row.idx + "." : "" }}&nbsp;</span
                      >
                      <span style="font-weight: 400; color: #4D4D4D;">{{
                        row.header_row ? row.name + ":" : ""
                      }}</span>
                      <bill-row
                        v-if="!row.header_row && row.connection.bill"
                        :el="row.connection.bill"
                        :bill-type="row.connection.billRowType"
                        @info-closed="onFinanceInfoClosed"
                      />
                      <movement-row
                        v-else-if="!row.header_row && row.connection.movement"
                        :el="row.connection.movement" :show-positions="false"
                      />
                    </div>
                    <div class="row no-wrap">
                      <span
                        v-if="!row.header_row && row.connection.bill && roundTo(row.connection.bill.PayedPercent, 4) < 100 && row.connection.bill.Descriptor !== 3"
                        style="font-size: 12px; color: #499259; margin-right: 5px"
                      >
                        {{ roundTo(row.connection.bill?.PayedPercent, 4) }}%
                      </span>
                      <span
                        v-else-if="!row.header_row && row.connection.bill"
                        style="font-size: 14px; color: #499259; margin-right: 5px"
                      >
                        {{ money(row.connection.bill?.TotalAmount) }}
                      </span>
                      <div
                        v-if="
                          !row.header_row && row.connection.bill &&
                          roundTo(row.connection.bill?.PayedPercent, 4) < 100 &&
                          row.connection.bill?.Descriptor !== 3
                        "
                        style="display: flex; flex-direction: column"
                      >
                        <payment-progress
                          :narrow="false"
                          :width="60"
                          :percent="Math.round(row.connection.bill?.PayedPercent)"
                        />
                        <span style="font-size: 12px; font-weight: 500">
                          {{ money(row.connection.bill?.PayedAmount) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
                <td
                  :colspan="row.header_row ? 3 : 1"
                  :style="row.header_row ? 'border-left: 0;' : ''"
                >
                  <div v-if="!row.header_row && row.connection.bill && row.connection.bill.Descriptor !== 3">
                    {{ roundTo(row.connection.percent, 2) }}%
                  </div>
                </td>
                <td v-if="!row.header_row">
                  {{ money(row.connection.amount) }}
                </td>
                <!-- income connection is not removable from the bill info dialog -->
                <td v-if="!row.header_row" class="cell-actions">
                  <q-btn
                    v-if="
                      canEdit && (
                        !row.connection.bill ||
                        row.connection.bill.CanBeDetached ||
                        row.connection.bill.Descriptor === 3
                      )
                    "
                    :disable="isLoading"
                    icon="close"
                    flat
                    class="cursor-pointer"
                    size="sm"
                    dense
                    no-caps
                    color="grey-6"
                    :title="$t('detach')"
                  >
                    <q-menu v-if="!isLoading">
                      <q-card>
                        <q-card-section class="row items-center">
                          <q-avatar
                            icon="delete"
                            size="md"
                            color="grey"
                            text-color="white"
                          />
                          <span class="q-ml-sm">
                            {{ $t("sure_delete") }}
                          </span>
                        </q-card-section>

                        <q-card-actions align="right">
                          <q-btn
                            size="sm"
                            flat
                            :label="$t('cancel')"
                            color="dark"
                            :ref="'cancelbtn' + idx"
                            v-close-popup
                          />
                          <q-btn
                            size="sm"
                            flat
                            :label="$t('remove')"
                            autofocus
                            color="dark"
                            :ref="'okbtn' + idx"
                            v-close-popup
                            @click="remove(row)"
                          />
                        </q-card-actions>
                      </q-card>
                    </q-menu>
                  </q-btn>
                </td>
              </tr>

              <!-- position rows -->
              <tbody style="display: contents" v-if="!row.header_row && row.connection.movement">
                <tr v-for="(storagepos, idsx) in row.connection.movement.Items" :key="'stp'+idsx">
                  <td v-if="!row.header_row" class="pos_cell">
                    <div class="row no-wrap items-baseline q-ml-md">
                      {{ idsx + 1 }})&nbsp;
                      <position-row
                        :id="storagepos.Id"
                        :el="getPositionFromNameInstance(storagepos)"
                        :hide-info-btn="true"
                      />
                    </div>
                  </td>
                  <td v-if="!row.header_row" class="shrink-col pos_cell">
                    <span>
                      {{ storagepos.ItemQuantity }}
                    </span>
                  </td>
                  <td v-if="!row.header_row" class="shrink-col pos_cell">
                    <span>
                      {{ money(storagepos.TotalAmount) }}
                    </span>
                  </td>
                  <!-- income connection is not removable from the bill info dialog -->
                  <td class="pos_cell">
                  </td>
                </tr>
              </tbody>
            </tbody>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from "vue-facing-decorator";
import { QBtn } from "quasar";
import { reactive } from "vue";
import _ from "lodash";
import {
  BillLinkedTypeDescriptor,
  BillSearchedTypeDescriptor,
  BillType,
  ParameterInstanceContainerType,
  V2FieldValueDisplayType,
  V2RecordAxisType,
  V2StorageItemMovementType,
} from "@/models/etc/types";
import {
  BillLinkedBase,
  BillWithOneLink,
  BillWithManyLinks,
  StorageItemMovementInFinances,
  BillSearchedWithConnections,
  StorageItemInMovement,
} from "@/models/interfaces/finances/finance-models";
import {
  ConnectionLine,
  BillRowProps,
} from "@/store/heartbeat-workers/useEntityStore";
import PaymentProgress from "@/components/multiedit/temporary/storageshared/PaymentProgress.vue";
import PaymentCreateComponent, {
  PaymentStructure,
} from "@/components/multiedit/temporary/info-dialogs/PaymentCreateComponent.vue";
import { financesStore } from "@/store/finances";
import { storageMovementsStore } from "@/store/storage/storage-movements";
import BillCreateForm, { BillStructure } from "./create/BillCreateForm.vue";
import CounterpartyCreateForm, {
  CounterpartyStructure,
} from "./create/CounterpartyCreateForm.vue";
import { CommonEntity } from "@/models/interfaces/common";
import { CounterpartySearched } from "@/models/interfaces/finances/counterparty-models";
import { V2ParameterValueType } from "@/models/etc/parameter-types";
import { mapStorageItemInstanceToParameterInstance } from "@/models/helpers/parameter-helpers";
import { ParameterInstance, ParameterInstanceContainer } from "@/models/interfaces/parameters/parameter-models";
import { ProjectContainer } from "@/models/interfaces/project/project-models";
import PositionRow from "@/components/multiedit/temporary/storageshared/PositionRow.vue";
import SelectorPopup from '@/components/common/aux-selector/SelectorPopup.vue';
import { roundTo } from "@/utils/auxfunc";
import { i18n } from "@/i18n";

@Component({
  name: "ProjectFinanceSection",
  emits: ["changed", "update:addMenuOpen"],
  components: {
    QBtn,
    PaymentProgress,
    PaymentCreateComponent,
    BillCreateForm,
    CounterpartyCreateForm,
    PositionRow,
    SelectorPopup,
  },
})
export default class ProjectFinanceSection extends Vue {
  private clearIconUrl: string = require("@/assets/arrow_back.svg");
  get clearIconName(): string {
    return `img:${this.clearIconUrl}`;
  }

  @Prop({ required: true, default: 0 }) readonly projectId!: number;
  @Prop({ default: null }) readonly project!: ProjectContainer | null;
  @Prop({ default: 0 }) readonly financeAccess!: number;
  @Prop({ default: null }) readonly addMenuTarget!: Element | null;
  @Prop({ default: false }) readonly addMenuOpen!: boolean;

  clientMenuVisible: boolean = false;

  finances_store: any | undefined = undefined;
  storage_move: any | undefined = undefined;

  cpLoaded: boolean = false;

  isLoading: boolean = false;
  cp_search_text: string = "";
  acc_search_text: string = "";

  // button hint texts
  attachHintText: string = '';
  createBillHintText: string = '';

  newPayment: PaymentStructure = reactive({
    paymentType: BillType.Incoming,
    paymentAmount: 0,
    paymentNumber: "",
    paymentDate: new Date(),
    currencyName: i18n.global.t('rub')+".",
    paymentCurrency: 1,
    paymentNote: "",
  } as PaymentStructure);

  newBill: BillStructure = reactive({
    billType: BillType.Incoming,
    billAmount: 0,
    billNumber: "",
    // paymentDate: new Date(),
    billNote: "",
  } as BillStructure);

  newCPModel: CounterpartyStructure = reactive({
    instance1C: null,
    INN: "",
    KPP: "",
    Account: "",
    bankAccount: "",
    bankName: "",
    BIK: "",
    corrAccount: "",
    jurAddress: "",
    legalUnit: "",
    Note: "",
  } as CounterpartyStructure);

  tmp_accounts: {
    Id: number;
    isPreloaded: boolean;
    billRowType: BillRowProps;
    Name: string;
    bill: BillSearchedWithConnections | BillLinkedBase;
  }[] = reactive([]);

  tmp_project_cps: any[] = reactive([]);
  tmp_project_cps_clients: any[] = reactive([]);
  tmp_adding_cps = reactive([]);
  tmp_cp_clients = reactive([]);

  selectedExistingBill: BillSearchedWithConnections | undefined = undefined;
  selectedExistingPayment: BillSearchedWithConnections | undefined = undefined;
  selectedExistingCP: CounterpartySearched | undefined = undefined;
  selectedExistingClient: CommonEntity | undefined = undefined;

  // tabs switch model
  accounts_tab = "account_selector";
  counterparties_tab = "project_cp";
  showSelector = false;
  newCPMode: boolean = false;

  roundTo(val: number, places: number) {
    return roundTo(val, places);
  }

  created() {
    this.finances_store = financesStore();
    this.storage_move = storageMovementsStore();
  }

  // право на изменение финансов
  get canEdit(): boolean {
    return this.financeAccess === 2;
  }

  // имя проекта для лейбла таба контрагентов
  get projectName(): string {
    return this.project?.Name ?? "";
  }

  get tmp_connections(): {
    idx: number;
    header_row: boolean;
    name: string;
    connection?: ConnectionLine;
  }[] {
    const rows: {
      idx: number;
      header_row: boolean;
      name: string;
      connection?: ConnectionLine;
    }[] = [];

    if (!this.project) {
      return rows;
    }

    const bills = (this.project.Bills as BillLinkedBase[]) ?? [];
    const expenditureMovements =
      (this.project.StorageItemExpenditureMovements as StorageItemMovementInFinances[]) ?? [];

    if (!bills.length && !expenditureMovements.length) {
      return rows;
    }

    const allConnections = bills.map((conn: BillLinkedBase) => {
      if (conn.Descriptor === BillLinkedTypeDescriptor.BillWithOneLink) {
        const c = conn as BillWithOneLink;
        return {
          conn_id: 0,
          percent: c.PayedPercent,
          amount: c.TotalAmount,
          debit: c.PayedAmount,
          movement: undefined,
          billRowType: BillRowProps.BillLinkedBase,
          bill: c,
          canEditAmounts: false,
          canEditDebits: false,
          canBeDeleted: false,
        } as ConnectionLine;
      } else if (conn.Descriptor === BillLinkedTypeDescriptor.BillWithManyLinks) {
        const c = conn as BillWithManyLinks;
        return {
          conn_id: 0,
          percent: c.LinkPercent,
          amount: c.LinkAmount,
          debit: c.PayedAmount,
          billRowType: BillRowProps.BillLinkedBase,
          bill: c,
          canEditAmounts: false,
          canEditDebits: false,
          canBeDeleted: false,
        } as ConnectionLine;
      } else if (conn.Descriptor === BillLinkedTypeDescriptor.Payment) {
        const c = conn;
        return {
          conn_id: 0,
          percent: 0,
          amount: c.TotalAmount,
          debit: 0,
          billRowType: BillRowProps.BillLinkedBase,
          bill: c,
          canEditAmounts: false,
          canEditDebits: false,
          canBeDeleted: false,
        } as ConnectionLine;
      }
    });

    const incoming = allConnections.filter(
      (conn) => conn?.bill?.Type === BillType.Incoming,
    );
    const outgoing = allConnections.filter(
      (conn) => conn?.bill?.Type === BillType.Outgoing,
    );
    const movements = expenditureMovements.map(
      (conn: StorageItemMovementInFinances) => {
        const sum = +(conn.Items ?? []).reduce(
          (s, a) => s + (a.TotalAmount ? +a.TotalAmount : 0),
          0,
        );
        return {
          conn_id: 0,
          percent: 100,
          amount: sum,
          debit: 0,
          billRowType: BillRowProps.BillLinkedBase,
          movement: conn,
          canEditAmounts: false,
          canEditDebits: false,
          canBeDeleted: false,
        } as ConnectionLine;
      },
    );

    if (movements.length) {
      rows.push({
        header_row: true,
        name: this.$t("expenses_transfers"),
        connection: undefined,
        idx: 0,
      });
      movements.forEach((move, move_i) => {
        rows.push({
          header_row: false,
          name: "",
          connection: move,
          idx: move_i + 1,
        });
      });
    }

    if (incoming.length) {
      rows.push({
        header_row: true,
        name: this.$t("incoming_invoices"),
        connection: undefined,
        idx: 0,
      });
      incoming.forEach((inc, inc_i) => {
        rows.push({
          header_row: false,
          name: "",
          connection: inc,
          idx: movements.length + inc_i + 1,
        });
      });
    }

    if (outgoing.length) {
      rows.push({
        header_row: true,
        name: this.$t("outgoing_invoices"),
        connection: undefined,
        idx: 0,
      });
      outgoing.forEach((outg, out_i) => {
        rows.push({
          header_row: false,
          name: "",
          connection: outg,
          idx: out_i + 1,
        });
      });
    }

    return rows;
  }

  // money display value formatting
  money(n: number) {
    return new Intl.NumberFormat("ru-RU", {
      // style: "currency",
      // currency: "RUB",
      minimumFractionDigits: 0, // Не показывать нули, если дробной части нет
      maximumFractionDigits: 4,
    }).format(n || 0);
  }

  getPositionFromNameInstance(pos: StorageItemInMovement) {
    const pos_copy = mapStorageItemInstanceToParameterInstance(
      pos.NameParameters
    );
    const vcode_cell = {
      Type: ParameterInstanceContainerType.SingleInstance,
      Instance: {
        TemplateId: 999,
        Unremovable: true,
        ValueType: V2ParameterValueType.String,
        StringValue: pos.VendorCode,
        NumberValue: null,
        DateValue: null,
        BoolValue: null,
        ValueSet: null,
        SelectedValue: null,
        ValueDisplayType: V2FieldValueDisplayType.Inline,
        Name: this.$t('sku'),
        Id: 0,
        Round: 2,
        RecordAxisType: V2RecordAxisType.Horizontal,
        RecordFields: [],
      } as ParameterInstance,
      ListTitle: null,
    } as ParameterInstanceContainer;

    return [vcode_cell, ...pos_copy];
  }

  get isNewCPModelEmpty() {
    return !this.newCPModel.INN || !this.newCPModel.Name;
  }

  // Контрагенты для табов меню добавления нужны только при открытии "+".
  // Грузим лениво один раз (единственный доп. запрос сверх данных проекта).
  async ensureCounterpartiesLoaded() {
    if (this.cpLoaded || !this.finances_store) {
      return;
    }
    const res = await this.finances_store.getProjectCounterparties({
      Id: this.projectId,
    });
    if (res && res.Clients && res.Clients.length) {
      this.tmp_project_cps_clients = res.Clients;
    }
    this.cpLoaded = true;
  }

  // Сообщаем странице, что данные изменились - она перезапросит проект,
  // после чего tmp_connections пересоберётся реактивно.
  notifyChanged() {
    this.$emit("changed");
  }

  CPShow() {
    this.newCPMode = true;
  }

  counterpartyFromFilter(ent: CommonEntity): CommonEntity {
    return ent;
  }

  counterpartyToFilter(ent: CommonEntity, original_filter: any) {
    return ent;
  }

  get canAttachBill(): boolean {
    if (this.isLoading) { return false }

    if (!this.selectedExistingBill && !this.selectedExistingPayment) {
      this.attachHintText = this.$t('must_select_invoice');
      return false;
    }

    if (this.selectedExistingBill) {
      if (
        !this.selectedExistingBill.Counterparty?.Id &&
        !this.selectedExistingCP
      ) {
        this.attachHintText = this.$t('must_select_counterparty');
        return false;
      }

      if (this.selectedExistingBill.Counterparty) {
        if (
          !this.selectedExistingBill.CounterpartyIsAttachedToClient &&
          !this.selectedExistingClient
        ) {
          this.attachHintText = this.$t('must_select_client_ka');
          return false;
        }
      } else {
        if (this.selectedExistingBill.Instance1C != this.selectedExistingCP?.Instance1C) {
          this.attachHintText = this.$t('one_c_instances_must_match');
          return false;
        }

        if (
          !(this.selectedExistingCP as any)?.AttachedToClient &&
          !this.selectedExistingClient
        ) {
          this.attachHintText = this.$t('must_select_client_ka');
          return false;
        }
      }
    }

    return true;
  }

  get canCreateBill(): boolean {
    this.createBillHintText = '';

    if (this.isLoading) { return false }

    if (
      (!this.newBill.billNumber.length && this.newBill.billType === 0) ||
      this.newBill.billAmount <= 0
    ) {
      this.createBillHintText = this.$t('must_fill_number_amount');
      return false;
    }

    if (this.isNewCPModelEmpty) {
      if (!this.selectedExistingCP) {
        this.createBillHintText = this.$t('must_select_counterparty');
        return false;
      }
      if (
        !(this.selectedExistingCP as any)?.AttachedToClient &&
        !this.selectedExistingClient
      ) {
        this.createBillHintText = this.$t('must_select_client_ka');
        return false;
      }
    } else {
      if (!this.selectedExistingClient) {
        this.createBillHintText = this.$t('must_select_client_ka');
        return false;
      }
    }

    return true;
  }

  @Watch("accounts_tab")
  handleMenuShow() {
    this.selectedExistingBill = undefined;
    this.selectedExistingPayment = undefined;
    this.selectedExistingCP = undefined;

    this.tmp_accounts.splice(0);
    this.tmp_adding_cps.splice(0);
    this.tmp_project_cps.splice(0);
    this.tmp_cp_clients.splice(0);

    this.newPayment = reactive({
      paymentType: BillType.Incoming,
      paymentAmount: 0,
      paymentNumber: "",
      paymentDate: new Date(),
      currencyName: this.$t('rub')+".",
      paymentCurrency: 1,
      paymentNote: "",
    } as PaymentStructure);

    this.newBill = reactive({
      billType: BillType.Incoming,
      billAmount: 0,
      billNumber: "",
      // paymentDate: new Date(),
      billNote: "",
    } as BillStructure);

    this.newCPModel = reactive({
      instance1C: null,
      Name: "",
      INN: "",
      KPP: "",
      Account: "",
      bankAccount: "",
      bankName: "",
      BIK: "",
      corrAccount: "",
      jurAddress: "",
      legalUnit: "",
      Note: "",
    } as CounterpartyStructure);

    // контрагенты нужны только для меню добавления - подгружаем при первом показе
    this.ensureCounterpartiesLoaded();

    // @ts-ignore
    if (this.$refs.acc_menu) {
      // @ts-ignore
      const menuElement = this.$refs.acc_menu.contentEl as HTMLElement;
      // Принудительно устанавливаем max-height: none; через JS
      menuElement && (menuElement.style.maxHeight = "unset");
      this.showSelector = true;
    }
  }

  // Меню управляется извне (v-model:add-menu-open со страницы) - синхронизируем закрытие
  onAddMenuHide() {
    this.showSelector = false;
    this.$emit("update:addMenuOpen", false);
  }

  get tmp_accounts_mut() {
    return _.cloneDeep(this.tmp_accounts);
  }

  get tmp_adding_cps_mut() {
    return _.cloneDeep(this.tmp_adding_cps);
  }

  get tmp_project_cps_mut() {
    return _.cloneDeep(this.tmp_project_cps);
  }

  get tmp_cp_clients_mut() {
    return _.cloneDeep(this.tmp_cp_clients);
  }

  @Watch("tmp_cp_clients_mut")
  async cpClientsChanged(newval: any, oldval: any) {
    if (!this.tmp_cp_clients_mut.length || _.isEqual(newval, oldval)) {
      if (!this.tmp_cp_clients_mut.length) {
        this.selectedExistingClient = undefined;
      }
      return;
    }

    const tmp_client: CommonEntity =
      this.tmp_cp_clients_mut[this.tmp_cp_clients_mut.length - 1];
    if (tmp_client) {
      this.selectedExistingClient = _.cloneDeep(tmp_client);
    }
    this.tmp_cp_clients = reactive([
      this.tmp_cp_clients_mut[this.tmp_cp_clients_mut.length - 1],
    ]);
  }

  @Watch("tmp_accounts_mut")
  async accountsChanged(newval: any, oldval: any) {
    // Взять первый счёт (он тут будет единственный), вызвать АПИ добавления к проекту и обновить всё, а tmp_accounts очистить
    if (!this.tmp_accounts_mut.length || _.isEqual(newval, oldval)) {
      if (!this.tmp_accounts_mut.length) {
        this.selectedExistingBill = undefined;
        this.selectedExistingPayment = undefined;
      }
      return;
    }

    const bill = this.tmp_accounts_mut[this.tmp_accounts_mut.length - 1].bill;

    if (bill) {
      if (bill.Descriptor === BillSearchedTypeDescriptor.Payment) {
        this.selectedExistingBill = undefined;
        this.selectedExistingPayment = bill;
      } else if (
        bill.Descriptor === BillSearchedTypeDescriptor.BillWithConnections
      ) {
        this.selectedExistingPayment = undefined;
        this.selectedExistingBill = bill;
      }
    }

    this.tmp_accounts = reactive([
      this.tmp_accounts_mut[this.tmp_accounts_mut.length - 1],
    ]);
  }

  @Watch("newCPModel", { deep: true })
  cp_model_watch() {
    if (this.isNewCPModelEmpty) {
      return;
    }

    this.selectedExistingCP = undefined;
    this.tmp_adding_cps.splice(0);
    this.tmp_project_cps.splice(0);
  }

  @Watch("tmp_adding_cps_mut")
  async addingCpsChanged(newval: any, oldval: any) {
    if (!this.tmp_adding_cps_mut.length || _.isEqual(newval, oldval)) {
      if (!this.tmp_adding_cps_mut.length) {
        this.selectedExistingCP = undefined;
      }
      return;
    }

    // reset other CP models
    this.tmp_project_cps.splice(0);
    this.newCPModel = reactive({
      instance1C: null,
      Name: "",
      INN: "",
      KPP: "",
      Account: "",
      bankAccount: "",
      bankName: "",
      BIK: "",
      corrAccount: "",
      jurAddress: "",
      legalUnit: "",
      Note: "",
    } as CounterpartyStructure);

    const tmp_cp: CounterpartySearched =
      this.tmp_adding_cps_mut[this.tmp_adding_cps_mut.length - 1];
    if (tmp_cp) {
      this.selectedExistingCP = _.cloneDeep(tmp_cp);
    }
    this.tmp_adding_cps = reactive([
      this.tmp_adding_cps_mut[this.tmp_adding_cps_mut.length - 1],
    ]);
  }

  @Watch("tmp_project_cps_mut")
  async projectCpsChanged(newval: any, oldval: any) {
    if (!this.tmp_project_cps_mut.length || _.isEqual(newval, oldval)) {
      if (!this.tmp_project_cps_mut.length) {
        this.selectedExistingCP = undefined;
      }
      return;
    }

    // reset other CP models
    this.tmp_adding_cps.splice(0);
    this.newCPModel = reactive({
      instance1C: null,
      Name: "",
      INN: "",
      KPP: "",
      Account: "",
      bankAccount: "",
      bankName: "",
      BIK: "",
      corrAccount: "",
      jurAddress: "",
      legalUnit: "",
      Note: "",
    } as CounterpartyStructure);

    const tmp_cp: CounterpartySearched =
      this.tmp_project_cps_mut[this.tmp_project_cps_mut.length - 1];
    if (tmp_cp) {
      this.selectedExistingCP = _.cloneDeep(tmp_cp);
    }
    this.tmp_project_cps = reactive([
      this.tmp_project_cps_mut[this.tmp_project_cps_mut.length - 1],
    ]);
  }

  get canCreatePayment() {
    if (this.isLoading) { return false }

    if (this.newPayment.paymentType == null || this.newPayment.paymentType === undefined ||
    !this.newPayment.paymentNumber.length ||
    this.newPayment.paymentAmount <= 0 ||
    !this.newPayment.paymentDate ||
    !this.newPayment.currencyName.length) {
      return false;
    }

    return true;
  }

  async addNewPayment() {
    if (!this.canCreatePayment) {
      return;
    }

    this.isLoading = true;

    await this.finances_store.projectPaymentAdd({
      Amount: this.newPayment.paymentAmount,
      Number: this.newPayment.paymentNumber,
      Note: this.newPayment.paymentNote,
      Date: this.newPayment.paymentDate,
      Type: this.newPayment.paymentType, // Тип счета, входящий 0 или исходящий 1
      Currency: this.newPayment.currencyName, // = 'руб.'
      CurrencyRate: this.newPayment.paymentCurrency > 0
              ? this.newPayment.paymentCurrency
              : 1,
      OwnerEntityId: this.projectId
    });

    this.isLoading = false;
    this.notifyChanged();
  }

  async addNewBill() {
    if (!this.canCreateBill) {
      return;
    }

    this.isLoading = true;

    let request: any = {
      ProjectId: this.projectId,
      BillContainer: {
        Sum: this.newBill.billAmount, // Сумма
        Type: this.newBill.billType, // Тип счета, входящий или исходящий
        Note: this.newBill.billNote // Комментарий
        // FileId; //Файл со счетом. Необходим только если счет входящий.
      }
    }

    if (this.newBill.billType === 0) {
      request.BillContainer.Number = this.newBill.billNumber // Номер счета. только для входящего счета.
    }

    if (this.isNewCPModelEmpty) {
      if (!this.selectedExistingCP) {
        this.isLoading = false;
        return;
      }
      request.ExistingCounterpartyId = this.selectedExistingCP.Id;
      if (!(this.selectedExistingCP as any)?.AttachedToClient && this.selectedExistingClient) {
        request.ClientId = this.selectedExistingClient.Id;
      }
    } else {
      if (this.selectedExistingClient) {
        request.ClientId = this.selectedExistingClient.Id;
      }

      request.CounterpartyContainer = {
        Name: this.newCPModel.Name, // Название
        TaxpayerNumber:  this.newCPModel.INN, // ИНН
        ReasonCode: this.newCPModel.KPP, // КПП
        PersonalAccount:  this.newCPModel.Account, // Лицевой счет
        BankAccount: this.newCPModel.bankAccount, // Банковский счет или расчетный счет
        BankName: this.newCPModel.bankName, // Название банка
        BankIdCode: this.newCPModel.BIK, // БИК
        CorrespondentBankAccount: this.newCPModel.corrAccount, // Корреспонденсткий счет банка
        LegalAddress: this.newCPModel.jurAddress, // Юр. адрес
        LegalForm: this.newCPModel.legalUnit, // Правовая форма
        Note: this.newCPModel.Note, // Комментарий

        CounterTaxpayerNumber: [10, 12],
        InstanceName1C: this.newCPModel.instance1C
      }
    }

    await this.finances_store.billAdd(request);

    this.isLoading = false;
    this.notifyChanged();
  }

  async AttachBill() {
    if (!this.canAttachBill) {
      return;
    }

    this.isLoading = true;
    if (this.selectedExistingPayment) {
      await this.finances_store.projectPaymentAttach({
        OwnerEntityId: this.projectId,
        PaymentId: this.selectedExistingPayment.Id,
      });
    } else if (this.selectedExistingBill) {
      let request: any = {
        ProjectId: this.projectId,
        ExistingBillId: this.selectedExistingBill.Id
        // ExistingCounterpartyId: bill.Counterparty.Id, // если добавляем в существующий КА
        // ClientId: number; // если КА не прикреплен к клиенту, укажем Id клиента куда прикрепляем
        // CounterpartyContainer: CounterpartyAddContainer; // Если КА еще нет и добавляем новый для привязки нового счета
      }

      if (!this.selectedExistingBill.Counterparty?.Id && this.selectedExistingCP) {
        request.ExistingCounterpartyId = this.selectedExistingCP.Id;
      }

      if (this.selectedExistingBill.Counterparty) {
        if (!this.selectedExistingBill.CounterpartyIsAttachedToClient && this.selectedExistingClient) {
          request.ClientId = this.selectedExistingClient.Id;
        }
      } else {
        if (!(this.selectedExistingCP as any)?.AttachedToClient && this.selectedExistingClient) {
          request.ClientId = this.selectedExistingClient.Id;
        }
      }

      await this.finances_store.billAdd(request);
    }

    this.isLoading = false;
    this.notifyChanged();
  }

  selectBillCounterparty() {
    if (this.selectedExistingCP || !this.isNewCPModelEmpty) {
      // @ts-ignore
      this.$refs.acc_menu_cp && this.$refs.acc_menu_cp.hide();
    }
  }

  async remove(conn: any) {
    this.isLoading = true;

    if (conn.connection?.bill) {
      if (
        conn.connection?.bill.Descriptor === BillLinkedTypeDescriptor.Payment
      ) {
        await this.finances_store.paymentDetach({
          Id: conn.connection?.bill.Id,
        });
      } else {
        await this.finances_store.billDetach({
          billId: conn.connection?.bill.Id,
          AttachEntityId: this.projectId,
        });
      }
    } else if (
      conn.connection?.movement &&
      conn.connection?.movement.MovementType !== V2StorageItemMovementType.In
    ) {
      await this.storage_move.detachValuedMovementFromProject({
        Id: conn.connection?.movement.Id,
      });
    }

    this.isLoading = false;
    this.notifyChanged();
  }

  /** Вызывается при закрытии окна FinanceInfoComponent; при изменениях просим страницу обновить проект */
  onFinanceInfoClosed(payload?: { hadChanges?: boolean }) {
    if (payload?.hadChanges) {
      this.notifyChanged();
    }
  }
}
</script>

<style lang="scss" scoped>
div.q-menu {
  overflow: hidden;
  max-height: unset !important;
}

.pos_cell {
  border-top: 0;
  border-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
